import { STAGE_AUTO_NAVIGATION,
    NAVIGATE_PAGE } from '../actions/actionTypes'

export default function reduce(state = {}, action: any) {
switch(action.type) {
    case NAVIGATE_PAGE:
        let navPageLoc = action.payload.stateLocation;
        return Object.assign({}, state, {
            [navPageLoc] : true
        });
    break;

    case STAGE_AUTO_NAVIGATION:
        let stageLocation = action.payload.stateLocation;
        let navUrl = action.payload.navUrl;
        return Object.assign({}, state, {
            [stageLocation] : navUrl
        });
    break;

    default:
        return state;
    break;
}
}



// WEBPACK FOOTER //
// ./modules/auto-nav-url-aon/reducers/index.ts